import React, { useEffect } from 'react';
import $ST from 'plugins/tfs/platformConfigs/staticTextMaps/packageOrderDetail';
import { Button, Form, Input, Select } from 'antd';
import Modal from 'components/ui-ant/Feedback/modal';
import { hasFormErrors } from 'theme/utils';
import '../../main/style.css';

const { Option } = Select;
const { CARGO_SELECTION_MODAL: $STPOD = {} } = $ST;

const CargoSelectionModal = (props = {}) => {
  const {
    form,
    visible,
    pendingAnyAction,
    actionData = {},
    onActionFire,
    onClose,
    companies = [],
    actionData: {
      actionParams: { label },
    },
  } = props;

  const {
    getFieldDecorator,
    getFieldsError,
    getFieldError,
    getFieldsValue,
    validateFields,
  } = form;

  const hasTrackNumberError = getFieldError('tracking_number');
  const hasCargoCompanyError = getFieldError('cargo_company');
  const rules = { rules: [{ required: true }] };

  useEffect(() => {
    validateFields();
  }, []);

  return (
    <Modal
      className='package-modal'
      visible={visible}
      onCancel={onClose}
      title={$STPOD.TITLE}
      centered
      footer={[
        <Button key='back' onClick={onClose}>
          {$ST.CANCEL}
        </Button>,
        <Button
          key='submit'
          type='primary'
          onClick={() => onActionFire(actionData, getFieldsValue())}
          disabled={pendingAnyAction || hasFormErrors(getFieldsError())}
        >
          {label || $ST.PACK}
        </Button>,
      ]}
    >
      <Form>
        <Form.Item
          help={false}
          label={$STPOD.TRACK_NUMBER}
          hasFeedback={!hasTrackNumberError}
          validateStatus={!hasTrackNumberError ? 'success' : ''}
        >
          {getFieldDecorator('tracking_number', rules)(<Input />)}
        </Form.Item>
        <Form.Item
          help={''}
          label={$STPOD.COMPANY_NAME}
          hasFeedback={!hasCargoCompanyError}
          validateStatus={!hasCargoCompanyError ? 'success' : ''}
        >
          {getFieldDecorator(
            'cargo_company',
            rules
          )(
            <Select>
              {companies.map(({ id, name, shippingCompany }) => (
                <Option key={id} value={shippingCompany}>
                  {name}
                </Option>
              ))}
            </Select>
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default Form.create({ name: 'cargoSelectionModal' })(
  CargoSelectionModal
);



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/oms/PackageOrderDetail/modals/cargo/index.js